/**
 * The way to the voluntary password change, from the Profile page.
 *
 * The change screen already existed, but the only path to it was the forced
 * rotation prompt. An account created through a sign-in provider holds no
 * password; the screen says so in words if that is where the person lands (the
 * profile payload does not tell the SPA which kind of account this is, so the
 * link cannot be hidden ahead of time).
 */
import { Link } from 'react-router-dom';
import { colors } from '../../styles/theme';

export default function ChangePasswordLink(): JSX.Element {
  return (
    <section
      className="rounded-2xl p-6 max-w-2xl mt-5"
      style={{ background: colors.surface, border: `1px solid ${colors.border}` }}
      aria-labelledby="profile-password-heading"
    >
      <h2 id="profile-password-heading" className="text-sm font-semibold mb-1" style={{ color: colors.ink }}>
        Password
      </h2>
      <p className="text-xs mb-3" style={{ color: colors.muted }}>
        Choose a new password. Your other active sessions will be signed out.
      </p>
      <Link
        to="/auth/change-password"
        className="inline-block text-sm font-semibold px-4 py-2 rounded-lg"
        style={{ background: colors.navy, color: '#FFFFFF' }}
      >
        Change password
      </Link>
    </section>
  );
}
